import * as React from 'react';

import { cx } from 'class-variance-authority';
import styles from '../TextField/textField.module.scss';
import Label from '../../Label';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & { label?: string }
>(({ className, label, id, rows = 4, ...props }, ref) => {
  const renderRoot = (id?: string) => {
    return (
      <textarea
        id={id}
        className={cx(styles.textField, className)}
        ref={ref}
        rows={rows}
        {...props}
      />
    );
  };

  if (label) {
    return (
      <div>
        <Label className={styles.label} htmlFor={id}>
          {label}
        </Label>
        {renderRoot(id)}
      </div>
    );
  }

  return renderRoot();
});
Textarea.displayName = 'Textarea';

export default Textarea;
